import { render, staticRenderFns } from "./MpError.vue?vue&type=template&id=77718080&scoped=true"
import script from "./MpError.vue?vue&type=script&lang=js"
export * from "./MpError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77718080",
  null
  
)

export default component.exports